module.exports = __webpack_public_path__ + "static/WB4-05cce443a89053a32a4162dcb4e3fcd5.jpg";